<template>
  <v-container
    :style="`width: ${isMobile && !isMap?'100vh':'auto'}; height:calc(100vh - 56px)`"
    class="pa-0"
    fluid
  >
    <v-row
      class="fill-height"
      fluid
      no-gutters
    >
      <v-btn
        v-if="isMobile"
        class="toggle-map"
        color="secondary"
        dark
        fab
        x-small
        @click="toggleMap"
      >
        <v-icon>{{isMap?'mdi-table':'mdi-map'}}</v-icon>
      </v-btn>
      <v-col
        v-show="!isMobile || !isMap"
        cols="12"
        md="4"
        class="pa-0"
      >
        <v-card
          class="fill-height"
          elevation="3"
          style="z-index:1"
        >
          <v-container
            fill-height
            class="pa-0"
          >
            <v-row
              no-gutters
              class="fill-height"
              style="width: 100%"
            >
              <!-- przyciski po lewej stronie -->
              <v-col
                :cols="isMobile ? '2' : '1'"
                class="pa-0 fill-height"
              >
                <v-row
                  no-gutters
                  align="center"
                  justify="center"
                  class="fill-height"
                  style="max-height: calc(100vh - 64px)"
                  v-show="!dialog"
                >
                  <v-item-group v-model="window">
                    <v-item
                      key="button--start"
                      v-slot:default="{ active, toggle }"
                    >
                      <v-col cols="12" class="px-1">
                        <v-tooltip right>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              :input-value="active"
                              icon
                              v-on="on"
                              @click="toggle"
                            >
                              <v-icon>mdi-home</v-icon>
                            </v-btn>
                          </template>
                          <span>Start</span>
                        </v-tooltip>
                      </v-col>
                    </v-item>
                    <v-item
                      v-for="(offer, offerIndex) in offers"
                      :key="`button__offer--${offer.id}`"
                      v-slot:default="{ active }"
                    >
                      <v-col
                        cols="12"
                        class="py-0 px-1"
                      >
                        <v-tooltip right>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              class="mb-1"
                              :input-value="active"
                              fab
                              x-small
                              color="#676767"
                              v-on="on"
                              @click="showOfferDetails(offer, offerIndex)"
                            >
                              <span style="color: #ffffff; font-size: 15px">
                                {{offerIndex + 1}}
                              </span>
                            </v-btn>
                          </template>
                          <span>{{ offer.desctiption || offer.name[$i18n.locale] }}</span>
                        </v-tooltip>
                      </v-col>
                    </v-item>
                  </v-item-group>
                </v-row>
              </v-col>
              <!-- karty ofert -->
              <v-col
                :cols="isMobile ? '10' : '11'"
                class="pa-0 fill-height"
                ref="content"
              >
                <v-window
                  v-model="window"
                  class="elevation-1 fill-height"
                  vertical
                >
                  <v-window-item key="window--start">
                    <v-container fluid>
                      <template v-if="title">
                        <v-row no-gutters>
                          <v-col>
                            <v-tooltip
                              bottom
                              allow-overflow
                              content-class="tooltip__span"
                            >
                              <template v-slot:activator="{ on }">
                                <h1
                                  ref="title"
                                  v-on="on"
                                  class="text-center primary--text project__title"
                                  color="black"
                                  v-bind:style="{'max-width': isMobile ? '40vh' : null}"
                                >{{ title[$i18n.locale] }}</h1>
                              </template>
                              <span>{{ title[$i18n.locale] }}</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                        <v-row no-gutters>
                          <v-col>
                            <h4
                              class="text-center primary--text"
                              color="primary"
                            >{{$i18n.t('presentation.offers')}}</h4>
                          </v-col>
                        </v-row>
                      </template>
                      <div
                        :style="{height: offersHeight}"
                        class="offers__cards"
                        v-bar="{
                          preventParentScroll: true
                        }"
                      >
                        <div>
                          <v-row class="pa-5">
                            <v-col
                              :cols="isMobile?'10':'6'"
                              v-for="(offer, offerIndex) in offers"
                              :key="`card__offer--${offer.id}`"
                            >
                              <v-badge style="height: 100%; width: 100%" left :content="offerIndex+1" offset-x="10" offset-y="10">
                              <v-card
                                class="mx-auto"
                                max-width="400"
                                height="100%"
                              >
                                <v-row
                                  class="flex-column"
                                  no-gutters
                                  style="height: inherit"
                                >
                                  <v-col>
                                    <v-img
                                      class="white--text"
                                      height="200px"
                                      :src="offer.mainPhoto"
                                    ></v-img>
                                  </v-col>
                                  <v-col>
                                    <v-tooltip
                                      bottom
                                      allow-overflow
                                      content-class="tooltip__span"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-card-title
                                          v-on="on"
                                          class="align-start offer__title pb-0"
                                        >{{ offer.desctiption || offer.name[$i18n.locale] }}</v-card-title>
                                      </template>
                                      <span>{{ offer.desctiption || offer.name[$i18n.locale] }}</span>
                                    </v-tooltip>
                                  </v-col>
                                  <v-spacer></v-spacer>

                                  <v-col>
                                    <v-card-text>
                                      <p>{{ offer.voivodship ? offer.voivodship + ', ' : null}} Polska</p>
                                      <br />
                                      <span class="text--primary">
                                        <span>
                                          {{$i18n.t('presentation.area')}}:
                                          {{offer.area ? offer.area + ' ha' : $i18n.t('default.noDataText')}}
                                        </span>
                                        <br />
                                      </span>
                                    </v-card-text>
                                  </v-col>

                                  <v-col>
                                    <v-card-actions>
                                      <v-row no-gutters justify="center" align="center">
                                        <v-col cols="3">
                                          <v-btn
                                            block
                                            icon
                                            color="primary"
                                            :title="$i18n.t(`presentation.navigate`)"
                                            @click="zoomToOffer(offer.id)"
                                          >
                                            <v-icon>mdi-magnify</v-icon>
                                          </v-btn>
                                        </v-col>
                                        <v-col cols="3">
                                          <v-btn
                                            block
                                            icon
                                            color="primary"
                                            :title="$i18n.t(`presentation.navigate`)"
                                            @click="navigateToOffer(offer.attributes.geometria)"
                                          >
                                            <v-icon>mdi-navigation</v-icon>
                                          </v-btn>
                                        </v-col>
                                        <v-col cols="3">
                                          <v-btn
                                            block
                                            icon
                                            :title="$i18n.t(`dashboard.table.details`)"
                                            color="primary"
                                            @click="showOfferDetails(offer, offerIndex)"
                                          >
                                            <v-icon>mdi-eye-outline</v-icon>
                                          </v-btn>
                                        </v-col>
                                        <v-col cols="3">
                                          <v-btn
                                            block
                                            icon
                                            :title="$i18n.t(`presentation.attachments`)"
                                            color="primary"
                                            @click="showOfferAttachments(offer)"
                                          >
                                            <v-icon>mdi-paperclip</v-icon>
                                          </v-btn>
                                        </v-col>
                                      </v-row>
                                    </v-card-actions>
                                  </v-col>
                                </v-row>
                              </v-card>
                              </v-badge>
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </v-container>
                  </v-window-item>
                  <v-window-item
                    :key="`window__offer--${offer.id}`"
                    v-for="offer in offers"
                  >
                    <v-container fluid>
                      <v-row>
                        <v-col>
                          <h1
                            class="text-center primary--text"
                            color="primary"
                          >{{ offer.title }}</h1>
                        </v-col>
                      </v-row>
                      <v-row v-bind:class="{'pa-5': !isMobile}">
                        <v-col>
                          <v-tabs
                            ref="tabs_1"
                            v-model="offer.tab"
                            centered
                            icons-and-text
                            class="pb-5"
                          >
                            <v-tab
                              v-bind:style="isMobile?'width:15px;font-size:10px':''"
                              :href="`#tab-photos-${offer.id}`"
                            >
                              {{$i18n.t(`presentation.photos`)}}
                              <v-icon>mdi-image</v-icon>
                            </v-tab>

                            <v-tab
                              v-bind:style="isMobile?'width:15px;font-size:10px':''"
                              :href="`#tab-attributes-${offer.id}`"
                            >
                              {{$i18n.t(`presentation.attributes`)}}
                              <v-icon>mdi-format-list-bulleted-square</v-icon>
                            </v-tab>

                            <v-tab
                              v-bind:style="isMobile?'width:15px;font-size:10px':''"
                              :href="`#tab-comments-${offer.id}`"
                            >
                              {{$i18n.t(`presentation.comments`)}}
                              <v-icon>mdi-comment-text</v-icon>
                            </v-tab>
                          </v-tabs>

                          <v-tabs-items
                            v-model="offer.tab"
                            style="width:100%; height: calc(100vh - 260px)"
                            class="fill-height"
                            v-bar="{
                              preventParentScroll: true,
                              scrollThrottle: 30,
                              resizeDebounce: 1000
                            }"
                          >
                            <v-tab-item :value="`tab-photos-${offer.id}`">
                              <template v-if="offer.photos.length > 0">
                                <v-row>
                                  <v-col :cols="isMobile?'11':'12'">
                                    <v-carousel
                                      style="height: auto !important"
                                      :show-arrows="!isMobile"
                                      :show-arrows-on-hover="!isMobile"
                                      @change="offer.currentPhoto = $event"
                                    >
                                      <v-carousel-item
                                        :key="`photos__${photo.entity_id}--${photo.id}`"
                                        v-for="photo in offer.photos"
                                        :src="photo.id === 'default' ? `${apiURL}/offers/${offer.id}/default_image?token=${token}` : `${apiURL}/files/${photo.id}`"
                                      ></v-carousel-item>
                                    </v-carousel>
                                    <v-row justify="center">
                                      <v-col
                                        cols="auto"
                                        class="pa-2"
                                      >
                                        <span
                                          class="title"
                                        >{{offer.photos[offer.currentPhoto][$i18n.locale]}}</span>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </template>
                              <template v-else>
                                <v-row
                                  class="photos__row--noContent"
                                  align="center"
                                  justify="center"
                                >
                                  <v-col cols="auto">
                                    <span>{{$i18n.t('presentation.noPhotos')}}</span>
                                  </v-col>
                                </v-row>
                              </template>
                            </v-tab-item>
                            <v-tab-item :value="`tab-attributes-${offer.id}`">
                              <v-col :cols="isMobile?'11':'12'">
                                <template v-if="hasAnyAttributes">
                                  <div
                                    style
                                    v-bar
                                  >
                                    <v-expansion-panels accordion>
                                      <v-expansion-panel
                                        v-for="group in
                                        attributesSchema
                                      "
                                        :key="group.name"
                                      >
                                        <v-expansion-panel-header>
                                          {{
                                          $i18n.t(
                                          `offer.categories.${group.name}`
                                          )
                                          }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content class="pt-1">
                                          <v-form>
                                            <v-row>
                                              <v-list
                                                two-line
                                                width="100%"
                                              >
                                                <v-list-item-group active-class="primary--text">
                                                  <template
                                                    v-for="(attribute, index) in group.attributes"
                                                  >
                                                    <template
                                                      v-if="getAttribute(offer.attributes[group.name], attribute.name).type === 'price'"
                                                    >
                                                      <PriceRows
                                                        :currencyRatio="currencyRatio"
                                                        :key="
                                                      `item_${group.name}_${attribute.name}--${offer.id}`
                                                    "
                                                        :attribute="getAttribute(offer.attributes[group.name], attribute.name)"
                                                      ></PriceRows>
                                                    </template>
                                                    <template
                                                      v-else-if="getAttribute(offer.attributes[group.name], attribute.name).type === 'dicts_list' && getAttribute(offer.attributes[group.name], attribute.name).value.length > 0"
                                                      v-for="(value,idx) in getAttribute(offer.attributes[group.name], attribute.name).value"
                                                    >
                                                      <DictsListAttribute
                                                        :fields="getAttribute(offer.attributes[group.name], attribute.name).fields"
                                                        :value="value"
                                                        :key="idx"
                                                      />
                                                    </template>
                                                    <template
                                                      v-else-if="getAttribute(offer.attributes[group.name], attribute.name).type === 'date_range'"
                                                    >
                                                      <DateRange
                                                        :attribute="getAttribute(offer.attributes[group.name], attribute.name)"
                                                        :key="index"
                                                      />
                                                    </template>
                                                    <v-list-item
                                                      v-else
                                                      :key="
                                                      `item_${group.name}_${attribute.name}--${offer.id}`
                                                    "
                                                    >
                                                      <v-list-item-content>
                                                        <v-list-item-title class="text-wrap">
                                                          <Attribute
                                                            :item="
                                                            getAttribute(offer.attributes[group.name], attribute.name).value

                                                          "
                                                            :translate="
                                                            getAttribute(offer.attributes[group.name], attribute.name).translate
                                                          "
                                                            :is-date="
                                                             getAttribute(offer.attributes[group.name], attribute.name).type ===
                                                              'date'
                                                          "
                                                            :is-contact="
                                                             getAttribute(offer.attributes[group.name], attribute.name).name ===
                                                              'kontakt_cbre'
                                                          "
                                                          ></Attribute>
                                                        </v-list-item-title>
                                                        <v-list-item-subtitle
                                                          v-html="
                                                            getItemSubtitle(
                                                              attribute,
                                                              getAttribute(offer.attributes[group.name], attribute.name)
                                                                .measure_unit
                                                            )
                                                          "
                                                        />
                                                      </v-list-item-content>
                                                    </v-list-item>
                                                    <v-divider
                                                      v-if="index + 1 <group.attributes.length"
                                                      :key="`divider_${group.name}_${attribute.name}--${offer.id}`"
                                                    />
                                                  </template>
                                                </v-list-item-group>
                                              </v-list>
                                            </v-row>
                                          </v-form>
                                        </v-expansion-panel-content>
                                      </v-expansion-panel>
                                    </v-expansion-panels>
                                  </div>
                                </template>
                                <template v-else>
                                  <v-row
                                    class="photos__row--noContent"
                                    align="center"
                                    justify="center"
                                  >
                                    <v-col cols="auto">
                                      <span>{{$i18n.t('presentation.noAttributes')}}</span>
                                    </v-col>
                                  </v-row>
                                </template>
                              </v-col>
                            </v-tab-item>
                            <v-tab-item :value="`tab-comments-${offer.id}`">
                              <v-col :cols="isMobile?'11':'12'">
                                <v-row>
                                  <v-list>
                                    <template v-for="comment in offer.comments">
                                      <v-list-item
                                        three-line
                                        :key="`comment__${comment.entity_id}--${comment.id}`"
                                      >
                                        <v-list-item-content>
                                          <v-list-item-title>{{comment.content}}</v-list-item-title>
                                          <v-list-item-subtitle>{{comment.user}}</v-list-item-subtitle>
                                          <v-list-item-subtitle>{{comment.created_at | dateFilter}}</v-list-item-subtitle>
                                        </v-list-item-content>
                                      </v-list-item>
                                    </template>
                                  </v-list>
                                </v-row>
                                <v-form
                                  :ref="`commentRef_${offer.id}`"
                                  class="pr-4"
                                >
                                  <v-row no-gutters>
                                    <v-col
                                      cols="12"
                                      md="12"
                                    >
                                      <v-text-field
                                        label="Autor"
                                        v-model="author"
                                        outlined
                                        :rules="[required]"
                                        :disabled="false"
                                      />
                                    </v-col>
                                  </v-row>
                                  <v-row no-gutters>
                                    <v-col
                                      cols="12"
                                      md="12"
                                    >
                                      <v-textarea
                                        outlined
                                        name="input-7-4"
                                        :rules="[required]"
                                        label="Treść komentarza"
                                        v-model="comment"
                                      />
                                    </v-col>
                                  </v-row>
                                  <v-row
                                    no-gutters
                                    class="justify-end"
                                  >
                                    <v-col cols="auto">
                                      <v-btn
                                        @click="addComment(offer)"
                                        color="primary"
                                      >{{$i18n.t('presentation.addComment')}}</v-btn>
                                    </v-col>
                                  </v-row>
                                </v-form>
                              </v-col>
                            </v-tab-item>
                          </v-tabs-items>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-window-item>
                </v-window>
                <!-- </div> -->
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col
        v-show="isMap"
        cols="12"
        md="8"
        class="pa-0"
      >
        <PresentationMap
          ref="map"
          :offers="offers"
          @onSelectedId="setSelectedOffer"
        />
      </v-col>
    </v-row>
    <DefaultDialog
      :withConfirmation="true"
      :withCancelButton="false"
      @success="checkPassword"
      :dialog="dialog"
      max-width="350px"
    >
      <template v-slot:header>
        <h1>{{ $i18n.t(`dialog.header.projectPresentation`) }}</h1>
      </template>
      <template v-slot:content>
        <v-text-field
          :label="$i18n.t('login.password')"
          type="password"
          v-model="password"
        />
      </template>
    </DefaultDialog>
    <PresentationOfferAttachmentsDialog
      :is-visible.sync="isOfferAttachmentsVisible"
      :offer="currentAttachmentsOffer"
      :restriction="linkID"
    />
  </v-container>
</template>

<script>
import axios from 'axios';
import PresentationMap from '@/components/presentation/PresentationMap';
import DateRange from '@/components/presentation/DateRange';
import DictsListAttribute from '@/components/presentation/DictsListAttribute';
import PriceRows from '@/components/presentation/PriceRows';
import Attribute from '@/components/dashboard/Attribute';
import DefaultDialog from '@/components/DefaultDialog';
import centroid from '@turf/centroid';
import PresentationOfferAttachmentsDialog from '@/components/presentation/PresentationOfferAttachmentsDialog';

// mixins
import tabsMixin from '@/mixins/tabsMixin';

const apiURL = process.env.VUE_APP_API_URL;

export default {
  name: 'Presentation',
  mixins: [tabsMixin],
  components: {
    PresentationMap,
    DateRange,
    DictsListAttribute,
    Attribute,
    DefaultDialog,
    PriceRows,
    PresentationOfferAttachmentsDialog
  },
  data: () => ({
    apiURL,
    currencyRatio: 0,
    title: {},
    offers: [],
    projectData: {},
    window: 0,
    // panelHeight: 200,
    colors: ['primary', 'secondary', 'yellow darken-2', 'red', 'orange'],
    attributesSchema: {},
    isMap: true,
    isMobile: false,
    isReady: false,
    canEdit: false,
    dialog: true,
    password: 'admin1',
    priceEur: undefined,
    photos: [],
    comments: [],
    comment: undefined,
    author: undefined,
    hasAnyAttributes: false,
    offersHeight: 0,
    currentAttachmentsOffer: {},
    isOfferAttachmentsVisible: false
  }),
  computed: {
    logged() {
      return this.$store.getters.getLogged;
    },
    user() {
      return this.$store.getters.getUser;
    },
    linkID() {
      return this.$route.params.uuid;
    },
    required() {
      return v => !!v || this.$i18n.t('default.requiredField');
    },
    token() {
      return this.$store.getters.getToken;
    }
  },
  methods: {
    addComment(offer) {
      if (this.$refs[`commentRef_${offer.id}`][0].validate()) {
        const payload = {
          id: offer.id,
          body: {
            restrictions: this.linkID,
            content: this.comment,
            user: this.author
          }
        };
        this.$store.dispatch('postPresentationComment', payload).then(r => {
          if (r) {
            this.$root.$emit(
              'showSnackbar',
              this.$i18n.t('offer.comments.addSucc')
            );
            offer.comments.unshift({
              id: r.comments,
              content: payload.body.content,
              entity_type: 'offer',
              entity_id: offer.id,
              created_at: new Date().toGMTString(),
              updated_at: null,
              user: payload.body.user,
              restrictions: payload.body.restrictions
            });
            this.$refs[`commentRef_${offer.id}`][0].reset();
          } else {
            this.$root.$emit(
              'showSnackbar',
              this.$i18n.t('offer.offers.errorDB')
            );
          }
        });
      }
    },
    checkPassword() {
      const payload = {
        uuid: this.linkID,
        password: this.password
      };
      this.$store.dispatch('checkPassword', payload).then(r => {
        if (r.status === 200) {
          if (r.data.correct) {
            this.dialog = false;
            this.getPresentationDetails();
            // this.fixPanel();
          } else {
            this.$root.$emit(
              'showSnackbar',
              this.$i18n.t('presentation.uncorrectPassword')
            );
          }
        } else {
          this.$root.$emit('showSnackbar', r);
        }
      });
    },
    calculateCurrency(curr) {
      if (curr === 'pln') {
        if (this.priceEur == null || this.priceEur == '') {
          this.attributes.price[0].value = '';
        } else {
          this.attributes.price[0].value =
            Math.round(
              (this.priceEur * r.data.rates[0].mid + Number.EPSILON) * 100
            ) / 100;
        }
      } else {
        if (
          this.attributes.price[0].value == null ||
          this.attributes.price[0].value == ''
        ) {
          this.priceEur = '';
        } else {
          this.priceEur =
            Math.round(
              (this.attributes.price[0].value / r.data.rates[0].mid +
                Number.EPSILON) *
                100
            ) / 100;
        }
      }
    },
    getAttribute(attributes, name) {
      return attributes.find(attribute => attribute.name === name);
    },
    getOfferName(data) {
      const name = this.getAttribute(data.name, 'nazwa_nieruchomosci');
      return name ? name.value : {};
    },
    getAttributeValue(attributes, name) {
      const attribute = this.getAttribute(attributes, name);
      return attribute && attribute.value ? attribute.value : null;
    },
    getItemSubtitle(attribute, unit) {
      const dict = {
        pow_kl_bonitacyjna: '[ha]',
        pum: '[m<sup>2</sup>]'
      }
      return `${attribute[`name_${this.$i18n.locale}`]} ${dict[attribute.name] || unit || ''}`;
    },
    getPresentationDetails() {
      this.$store
        .dispatch('getPresentation', this.linkID)
        .then(r => {
          const { title, offers, attribute_config } = r.projects;
          this.title = title;

          this.attributesSchema = attribute_config.filter(group => {
            group.attributes = group.attributes.filter(
              attribute => attribute.visible
            );
            return group.attributes.length > 0;
          });
          this.hasAnyAttributes = this.attributesSchema.length > 0;
          // sad but true
          this.$nextTick(() => {
            const titleHeight = this.$refs.title.offsetHeight;
            this.offersHeight = `calc(100vh - 150px - ${titleHeight}px)`;
          });
          const offersRequests = offers.map(offer =>
            this.$store.dispatch('getOffer', {
              id: offer,
              params: {
                presentation_uuid: this.linkID
              }
            })
          );

          return Promise.all(offersRequests);
        })
        .then(offersResponse => {
          const offers = offersResponse.map(offer => {
            const { config, data } = offer;
            const [offerID] = config.url.split('/').slice(-1);
            return {
              id: Number(offerID),
              name: this.getOfferName(data.offers),
              attributes: data.offers,
              area: this.getAttributeValue(
                data.offers.site_description,
                'pow_dzialki'
              ),
              voivodship: this.getAttributeValue(
                data.offers.localization,
                'wojewodztwo'
              ),
              comments: null,
              photos: [],
              tab: undefined,
              currentPhoto: 0,
              mainPhoto: `${apiURL}/offers/${offerID}/default_image?token=${this.token}`,
              hasAttachments: data.offers.has_attachments,
              desctiption: data.offers.description
            };
          });
          this.$store.dispatch('getOwners').then(r => {
            //
            const owners = r.data.owners;
            for (let idx in offers) {
              let offerOwners = [];
              for (let owner of offers[
                idx
              ].attributes.conditions_and_ownership.find(
                att => att.name === '__wlasciciele'
              ).value) {
                const offerOwnerType = owner.wlasciciel_typ;
                if (owners.find(o => o.id === owner.id)) {
                  const findOwner = owners.find(o => o.id === owner.id);
                  findOwner.wlasciciel_typ = offerOwnerType;
                  offerOwners.push(findOwner);
                }
              }
              offers[idx].attributes.conditions_and_ownership.find(
                att => att.name === '__wlasciciele'
              ).value = offerOwners;
            }
          });
          setTimeout(() => {
            this.$refs.map.zoomToExtent(
              this.$refs.map
                .getLayerByName('offers')
                .getSource()
                .getExtent()
            );
          }, 0);
          const filesRequests = offers.map(offer =>
            this.$store.dispatch('getAttachments', {
              type: 'offer',
              id: offer.id,
              params: {
                only_graphics: true,
                restrict: this.linkID
              }
            })
          );
          this.offers = offers;
          return Promise.all(filesRequests);
        })
        .then(filesResponse => {
          for (const i in filesResponse) {
            const { files } = filesResponse[i].data;
            // tablica zapytań została stworzona na bazie tablicy ofert,
            // więc kolejność jest ta sama
            this.offers[i].photos = [
              ...files.offer,
              ...[].concat(...files.parcels)
            ];
            if (this.offers[i].photos.length === 0) {
              this.offers[i].photos.push({
                id: 'default',
                pl: '',
                en: ''
              });
              this.offers[i].mainPhoto = `${apiURL}/offers/${this.offers[i].id}/default_image?token=${this.token}`;
            } else if (this.offers[i].photos.length > 0) {
              this.offers[
                i
              ].mainPhoto = `${apiURL}/files/${this.offers[i].photos[0].id}`;
            }
          }
        })
        .catch(e => {
          this.$root.$emit('showSnackbar', e);
        });
    },
    async showOfferAttachments(offer) {
      this.currentAttachmentsOffer = offer;
      this.isOfferAttachmentsVisible = true;
    },
    async showOfferDetails(offer, offerIndex) {
      if (!offer.comments) {
        const commentsRequest = this.$store.dispatch('getComments', {
          type: 'offer',
          id: offer.id,
          params: {
            restrict: this.linkID
          }
        });
        const currencyRequest = axios({
          url: 'https://api.nbp.pl/api/exchangerates/rates/A/EUR/?format=json',
          baseURL: '/'
        });
        try {
          const [commentsRes, currencyRes] = await Promise.all([
            commentsRequest,
            currencyRequest
          ]);

          this.currencyRatio = currencyRes.data.rates[0].mid;
          offer.comments = [
            ...commentsRes.data.comments.offer,
            ...[].concat(...commentsRes.data.comments.parcels)
          ];
        } catch (e) {
          this.$root.$emit('showSnackbar', e);
        }
      }

      this.window = offerIndex + 1;
      this.zoomToOffer(offer.id);
      const epochInSeconds = Math.round(Date.now() / 1000);
      this.$store.dispatch('postPresentationStats', {
        id: this.linkID,
        body: {
          event_type: 'click',
          offer_id: offer.id,
          event_time: epochInSeconds,
          end_time_timestamp: epochInSeconds,
          parcel_id: undefined
        }
      });
    },
    navigateToOffer(offerGeometry) {
      const offerCentroid = centroid(offerGeometry);
      const [x, y] = offerCentroid.geometry.coordinates;
      const iOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      const navi_url = iOS
        ? `https://maps.apple.com/?daddr=${y},${x}`
        : `https://maps.google.com/maps/dir//${y},${x}`;
      window.open(navi_url, '_blank');
    },
    resizeMap() {
      setTimeout(() => {
        this.$refs.map.map.updateSize();
      }, 0);
    },
    zoomToOffer(offerID) {
      this.$refs.map.zoomToOfferById(offerID);
    },
    setSelectedOffer(id) {
      const offer = this.offers.find(offer => offer.id === id);
      const index = this.offers.indexOf(offer);
      if (offer) {
        this.showOfferDetails(offer, index);
      }
    },
    toggleMap() {
      this.isMap = !this.isMap;
      this.resizeMap();
    }
  },
  mounted() {
    if (window.innerWidth < 1000) {
      this.isMobile = true;
      this.isMap = false;
    }
    window.onresize = () => {
      if (window.innerWidth < 1000) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
        this.isMap = true;
      }
      this.resizeMap();
    };
  },
  beforeMount() {
    this.$i18n.locale = window.navigator.language === 'pl-PL' ? 'pl' : 'en';
  }
};
</script>


<style lang="scss">
html {
  overflow: hidden;
  .project__title {
    margin:auto;
    overflow: hidden;
    white-space:nowrap;
    display: block !important;
    text-overflow: ellipsis;
  }
  .project__title,
  .offer__title {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    word-break: normal;
    height: 120px
  }
}

@media (max-width: 1000px) {
  .v-carousel__item {
    height: auto !important;
  }
}

.v-carousel__controls {
  height: 35px;
}
// .offers__cards {
//   height: calc(100vh - 200px - var(--title-height));
// }
.v-carousel__item {
  .v-image__image {
    background-size: contain !important;
  }
}

.v-responsive__content {
  width: 100% !important;
}

.photos__row--noContent {
  height: 200px;
}

.toggle-map {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 15;
}
.mobile-tab {
  color: red;
  background-color: red;
  width: 20px !important;
  font-size: 10 !important;
}

// ::-webkit-scrollbar {
//   width: 0px;
// }
</style>
